const ACCEPT_NEW_FEATURES = 'ACCEPT_NEW_FEATURES';

export const acceptNewFeatures = (lastDate, fileDate) => ({
    type: ACCEPT_NEW_FEATURES,
    lastDate, fileDate
});

// Reducer
const _defaultState = () => ({
    disable: false
});


export const reducer = (state = _defaultState(), action) => {
    switch (action.type) {
    case ACCEPT_NEW_FEATURES:
        return {
            ...state,
            lastDate: action.lastDate,
            fileDate: action.fileDate
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/newFeatures.js